import React, { useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import dayjs from "dayjs";
import apiClient from "../../BaseUrl/apiClient.js";
import "../../css/entry.css";
import "../../css/color.css";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { useAuthentication } from "../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../constants/constants";
import { getBottomNavigationActionUtilityClass } from "@mui/material";
const IndentEntry = () => {
  const [varindentNumber, setvarindentNumber] = useState("");
  const [vardateofIndent, setvardateofIndent] = useState(null);
  const [varitemname, setvaritemname] = useState("");
  const [varindentItemQty, setvarindentItemQty] = useState("");
  const [varindentItemValue, setvarindentItemValue] = useState("");
  const [error, setError] = useState("");
  //const [dateerror, setDateError] = useState(null);
  const today = dayjs();
  const minCalDate = dayjs("2023-04-01");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const navigate = useNavigate();
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const consigee_consignee = tokenServiceDetails?.consignee;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const { auth } = useAuthentication();
  // console.log(consigee_consignee);
  const startRef = useRef(null);
  const handleQuantityChange = (value) => {
    setvarindentItemQty(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setvarindentItemValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  // Function to fetch Consignee from the API
  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const UpdateIndentData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!vardateofIndent) {
      formErrors.errDate = "Invalid Indent Date";
    }

    if (parseFloat(varindentItemQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (varindentItemValue.length === 0)
      formErrors.val = "Value should be more then zero";

    if (varindentItemQty.length === 0)
      formErrors.qty = "Qty should be more then zero";

    if (parseFloat(varindentItemValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (varindentNumber.length === 0)
      formErrors.indent = "Indent Number Should not be Blank";

    if (varitemname.length === 0)
      formErrors.name = "Item Name Should not be Blank";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const Indentdt = new Date(vardateofIndent);
      const indentreceiptdt =
        Indentdt.getFullYear() +
        "/" +
        parseInt(Indentdt.getMonth() + 1) +
        "/" +
        Indentdt.getDate();

      apiClient
        .post("/indententry", {
          varindentNumber,
          vardateofIndent: indentreceiptdt,
          varitemname,
          consignee,
          varindentItemQty,
          varindentItemValue,
          varentryUser: uname,
          ip,
          unit,
        })
        .then(function (response) {
          setError(response.data);
          setvarindentNumber("");
          setvaritemname("");
          setvarindentItemQty([]);
          setvarindentItemValue([]);
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Indent Not Allowed");
          }
        });
    }
  };
  useEffect(() => {
    if (!consignees.length) return;

    if (auth?.userrights === USER_RIGHTS.CONSIGNEE) {
      const userConsigneeCode = String(consigee_consignee);

      const match = consignees.find(
        (c) => String(c.ConsigneeCode) === userConsigneeCode
      );

      if (match) {
        setconsignee(String(match.ConsigneeCode));
      } else {
        console.warn(
          "Consignee from token not found in list:",
          userConsigneeCode
        );
        setconsignee("");
      }
    } else {
      // Non-consignee users → select first by default
      setconsignee(String(consignees[0].ConsigneeCode));
    }
  }, [consignees, auth, consigee_consignee]);




  useEffect(() => {
    if (units.length > 0) {
      const defaultUnit = units.find(u => u.unitcode === "UNT");
      setunit(defaultUnit ? defaultUnit.unitcode : units[0].unitcode);
    }
  }, [units]);




  useEffect(() => {
    fetchConsignees();
    fetchUnit();
    // setunit("UNT");
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

    }
  }, []);



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };


  // console.log("consignee:", consignee);
  return (
  <>
    <style>
      {`
        /* =====================================================
           INDENT ENTRY - DASHBOARD THEME
        ===================================================== */

        .indent-page {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;
          padding: 12px;
        }


        /* =====================================================
           MAIN CARD
        ===================================================== */

        .indent-card {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          background: #ffffff !important;

          border-radius: 16px !important;

          border: 1px solid #dce5f0 !important;

          box-shadow:
            0 6px 24px rgba(0, 68, 145, 0.10) !important;

          overflow: hidden;

          box-sizing: border-box;
        }


        /* =====================================================
           BLUE HEADER
        ===================================================== */

        .indent-header {
          width: 100%;

          padding: 18px 24px;

          background:
            linear-gradient(
              135deg,
              #0d47a1 0%,
              #1565c0 48%,
              #1976d2 100%
            );

          color: #ffffff;

          box-sizing: border-box;
        }


        .indent-header-title {
          margin: 0;

          font-size: 20px;

          font-weight: 700;

          line-height: 1.3;

          letter-spacing: 0.2px;
        }


        .indent-header-subtitle {
          margin-top: 4px;

          font-size: 13px;

          opacity: 0.90;
        }


        /* =====================================================
           FORM CONTENT
        ===================================================== */

        .indent-content {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          padding: 22px;

          box-sizing: border-box;
        }


        /* =====================================================
           FORM GRID
        ===================================================== */

        .indent-grid {
          display: grid;

          grid-template-columns:
            repeat(2, minmax(0, 1fr));

          gap: 18px;

          width: 100%;

          box-sizing: border-box;
        }


        .indent-field {
          width: 100%;
          min-width: 0;

          box-sizing: border-box;
        }


        /* Full width fields */

        .indent-field-full {
          grid-column: 1 / -1;
        }


        /* =====================================================
           QUANTITY / UNIT / VALUE
        ===================================================== */

        .indent-small-fields {
          grid-column: 1 / -1;

          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 18px;

          width: 100%;

          min-width: 0;
        }


        /* =====================================================
           SECTION LABEL
        ===================================================== */

        .indent-section-label {
          display: flex;

          align-items: center;

          gap: 8px;

          margin-bottom: 12px;

          color: #1565c0;

          font-size: 14px;

          font-weight: 700;
        }


        .indent-section-label::before {
          content: "";

          width: 4px;

          height: 18px;

          border-radius: 5px;

          background:
            linear-gradient(
              180deg,
              #0d47a1,
              #1976d2
            );
        }


        /* =====================================================
           CONSIGNEE AREA
        ===================================================== */

        .indent-consignee {
          width: 100%;

          max-width: 50%;

          min-width: 0;

          margin-top: 18px;
        }


        /* =====================================================
           BUTTON AREA
        ===================================================== */

        .indent-actions {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 15px;

          width: 100%;

          margin-top: 25px;

          padding-top: 18px;

          border-top:
            1px solid #e3eaf3;

          box-sizing: border-box;
        }


        .indent-save-btn,
        .indent-close-btn {
          min-width: 125px;

          min-height: 42px;

          padding: 10px 22px;

          border: none;

          border-radius: 10px;

          color: #ffffff;

          font-size: 14px;

          font-weight: 700;

          cursor: pointer;

          transition:
            transform 0.18s ease,
            box-shadow 0.18s ease;
        }


        .indent-save-btn {
          background:
            linear-gradient(
              135deg,
              #0d47a1,
              #1976d2
            );

          box-shadow:
            0 4px 12px rgba(21,101,192,0.22);
        }


        .indent-save-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(21,101,192,0.30);
        }


        .indent-close-btn {
          background:
            linear-gradient(
              135deg,
              #c62828,
              #e53935
            );

          box-shadow:
            0 4px 12px rgba(198,40,40,0.18);
        }


        .indent-close-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(198,40,40,0.28);
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 900px) {

          .indent-grid {
            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 14px;
          }

          .indent-small-fields {
            gap: 14px;
          }

          .indent-consignee {
            max-width: 100%;
          }
        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 600px) {

          .indent-page {
            padding: 6px;
          }


          .indent-card {
            border-radius: 12px !important;
          }


          .indent-header {
            padding: 15px 16px;
          }


          .indent-header-title {
            font-size: 17px;
          }


          .indent-header-subtitle {
            font-size: 11px;
          }


          .indent-content {
            padding: 15px;
          }


          .indent-grid {
            grid-template-columns: 1fr;

            gap: 13px;
          }


          .indent-small-fields {
            grid-column: auto;

            grid-template-columns: 1fr;

            gap: 13px;
          }


          .indent-field-full {
            grid-column: auto;
          }


          .indent-consignee {
            max-width: 100%;

            margin-top: 13px;
          }


          .indent-actions {
            flex-direction: column-reverse;

            align-items: stretch;

            gap: 10px;

            margin-top: 20px;

            padding-top: 15px;
          }


          .indent-save-btn,
          .indent-close-btn {
            width: 100%;

            min-height: 44px;
          }
        }


        /* =====================================================
           VERY SMALL MOBILE
        ===================================================== */

        @media (max-width: 400px) {

          .indent-page {
            padding: 4px;
          }


          .indent-header {
            padding: 13px;
          }


          .indent-header-title {
            font-size: 16px;
          }


          .indent-content {
            padding: 12px;
          }
        }
      `}
    </style>

    <div className="indent-page">

      <Card className="indent-card">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="indent-header">

          <div className="indent-header-title">
            Indent Entry
          </div>

          <div className="indent-header-subtitle">
            Enter indent, item, quantity and consignee details
          </div>

        </div>


        {/* =================================================
            ERROR MESSAGE
        ================================================= */}

        {error && (
          <ToasterAlerts
            type="error"
            title="Message"
            errorMessage={error}
            displaytime={1000}
            handleClose={() => {
              setError("");
            }}
          />
        )}


        {/* =================================================
            FORM CONTENT
        ================================================= */}

        <CardContent
          sx={{
            padding: 0,
            "&:last-child": {
              paddingBottom: 0,
            },
          }}
        >

          <div className="indent-content">

            <div className="indent-section-label">
              Indent Information
            </div>


            {/* =================================================
                FIRST ROW
            ================================================= */}

            <div className="indent-grid">

              <div className="indent-field">

                <CustomTextField
                  label="Enter Indent Number (Max 50 Characters)*"
                  value={varindentNumber}
                  onChange={(e) => {
                    setvarindentNumber(
                      e.target.value.toUpperCase()
                    );
                  }}
                  placeholder="Enter Indent Number"
                  maxLength={50}
                  error={!!errors.indent}
                  helperText={errors.indent}
                />

              </div>


              <div className="indent-field">

                <DatePickerComponent
                  label="Date of Indent*"
                  id="indentdate"
                  value={vardateofIndent}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setvardateofIndent
                    )
                  }
                  error={errors.errDate}
                  maxDate={today}
                  minDate={minCalDate}
                />

              </div>


              {/* =================================================
                  ITEM NAME
              ================================================= */}

              <div className="indent-field-full">

                <CustomTextField
                  label="Enter Item Name (Max 200 Characters)*"
                  value={varitemname}
                  onChange={(e) => {
                    setvaritemname(e.target.value);
                  }}
                  placeholder="Enter Item Name"
                  maxLength={200}
                  multiline={true}
                  minRows={3}
                  error={!!errors.name}
                  helperText={errors.name}
                />

              </div>


              {/* =================================================
                  QUANTITY / UNIT / VALUE
              ================================================= */}

              <div className="indent-small-fields">

                <div className="indent-field">

                  <NumericTextField
                    id="ItemQuantity"
                    label="Item Quantity"
                    title="Item Quantity"
                    error={errors.qty}
                    value={varindentItemQty}
                    onChange={handleQuantityChange}
                  />

                </div>


                <div className="indent-field">

                  <DropdownfromDatabaseList
                    Options={units}
                    option={unit}
                    setOptionValue={setunit}
                    DisplayItem1="unit"
                    DisplayItem2="unitcode"
                    showKeyInLabel={true}
                  />

                </div>


                <div className="indent-field">

                  <NumericTextField
                    id="ItemValue"
                    label="Item Value"
                    title="Item Value"
                    error={errors.val}
                    value={varindentItemValue}
                    onChange={handleValueChange}
                  />

                </div>

              </div>

            </div>


            {/* =================================================
                CONSIGNEE
            ================================================= */}

            <div className="indent-section-label"
              style={{
                marginTop: "24px",
              }}
            >
              Consignee Information
            </div>


            <div className="indent-consignee">

              <DropdownfromDatabaseList
                Options={consignees}
                option={String(consignee)}
                setOptionValue={(val) =>
                  setconsignee(String(val))
                }
                DisplayItem1="Shop"
                DisplayItem2="ConsigneeCode"
                showKeyInLabel={true}
                disabled={
                  auth?.userrights ===
                    USER_RIGHTS.CONSIGNEE &&
                  consignee !== "91030"
                }
              />

            </div>


            {/* =================================================
                ACTION BUTTONS
            ================================================= */}

            <div className="indent-actions">

              <button
                className="indent-save-btn"
                type="button"
                onClick={UpdateIndentData}
                title="Click for Data Entry"
              >
                Data Save
              </button>


              <button
                className="indent-close-btn"
                type="button"
                onClick={handleClose}
                title="Close"
              >
                Close
              </button>

            </div>

          </div>

        </CardContent>

      </Card>

    </div>
  </>
);
};

export default IndentEntry;
